import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {DataTableComponent} from "../../shared/components/data-table/data-table.component";
import {TableLazyEvent} from '../../shared/contracts/table-column.interface';
import {Toast} from "primeng/toast";
import {FormsModule} from '@angular/forms';
import {LoaderComponent} from '../../shared/components/loader/loader.component';
import {TableModule} from 'primeng/table';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';

@Component({
  selector: 'app-entity-crud-page-template',
  imports: [
    DataTableComponent,
    Toast,
    FormsModule,
    LoaderComponent,
    TableModule,
    Button,
    Tooltip
  ],
  templateUrl: './entity-crud-page-template.component.html',
  styleUrl: './entity-crud-page-template.component.scss'
})
export class EntityCrudPageTemplateComponent {
  @Input() data: any[] = [];
  @Input() columns: any[] = [];
  @Input() loading: boolean = false;
  @Input() enableSearch: boolean = false;
  @Input() enableFilterReset: boolean = false;
  @Input() canCreate: boolean = true;

  @Input() topbarTemplate?: TemplateRef<any>;

  @Output() onCreate = new EventEmitter<void>();
  @Output() onDeleteSelected = new EventEmitter<any[]>();

  @Input() totalRecords = 0;
  @Input() rows = 10;
  @Output() onLazyLoad = new EventEmitter<TableLazyEvent>();

  selectedData: any[] = [];

  onSelectionChanged(event: any) {
    this.selectedData = event;
  }
}


